import(/* webpackMode: "eager", webpackExports: ["RenderBuilderContent"] */ "/vercel/path0/src/components/builder.tsx");
